
import ServiceAlarmApi from './src/Tranresources'


let apis = {
    ServiceAlarmApi

};

export default apis;
